import { Button, Drawer, DrawerBody, DrawerCloseButton, DrawerContent, DrawerFooter, DrawerHeader, DrawerOverlay, Input, ListItem, UnorderedList, useDisclosure } from "@chakra-ui/react"
import { useEffect, useState } from "react"
import { useRecoilState } from "recoil"
import { useApi } from "../../../../api"
import { ICargo, ISeries } from "../../../../interfaces"
import { nftAssetSeriesDrawerAtom } from "../../../../stores/main"
import { useToast } from '@chakra-ui/react'

export const NftMyAssetDrawer = () => {
  const projectCode = 'NFT';
  const api = useApi(projectCode)
  const toast = useToast()
  const [isOpen, setIsOpen] = useRecoilState(nftAssetSeriesDrawerAtom)
  const onClose = () => {
    setIsOpen(false)
  }
  const [inputboxValue, setInputBoxValue] = useState('')
  const [series, setSeries] = useState<ISeries[]>()

  useEffect(() => {
    const memberNo = localStorage.getItem('memberNo');
    if (!memberNo) return;
    if (series) return;
    setSeries([])
    api.getNftSeries(memberNo, (cargo: ICargo) => {
      if (cargo.returnCode === '000000') {
        setSeries(cargo.info)
      }
    })
  }, [api, series])

  return (
    <>
      <Drawer
        isOpen={isOpen}
        placement='right'
        onClose={onClose}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>NFT 系列管理</DrawerHeader>

          <DrawerBody>
            <Input placeholder='Type here...' onChange={(e) => {
              setInputBoxValue(e.target.value);
            }} />
            <Button variant='outline' mt={3} mr={3} onClick={() => {
              if (!inputboxValue) {
                toast({
                  title: '請輸入資料',
                  position: 'bottom-right',
                  status: 'warning',
                  duration: 9000,
                  isClosable: true,
                })
                return;
              }
              if (series) {
                setSeries([...series, {title: inputboxValue, idNftSeries: Math.floor(Math.random() * 9999) + 1000}])
              }
              api.createNftSeries(inputboxValue, (cargo: ICargo) => {
                if (cargo.returnCode !== '000000') {
                  toast({
                    title: '新增失敗',
                    position: 'bottom-right',
                    status: 'error',
                    duration: 9000,
                    isClosable: true,
                  })
                }
              })
            }} width='full'>
              新增
            </Button>
            <UnorderedList mt={5}>
            {
              series?.map((item, index) => {
                return <ListItem key={index}>{item.title}</ListItem>
              })
            }
            </UnorderedList>
            
          </DrawerBody>

          <DrawerFooter>
            
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  )
}

